import React from "react";
import {Col, Nav, NavItem, NavLink, Row,} from "reactstrap";
import classnames from "classnames";

const RequestReceivedTabComponent = (props) => {

    const oneOnOneClassNames = classnames({active: props.activeTab === "1", "cursor-pointer": true});
    const groupClassNames = classnames({active: props.activeTab === "2", "cursor-pointer": true});

    return (
        <Row>
            <Col md="12">
                <Nav tabs className="availability-requests">
                    <NavItem className="mx-4">
                        <NavLink
                            className={oneOnOneClassNames}
                            onClick={() => props.toggle("1")}>
                            1-ON-1 REQUESTS
                            ({props.oneToOneRequestCount})
                        </NavLink>
                    </NavItem>
                    <NavItem className="ml-md-3">
                        <NavLink
                            className={groupClassNames}
                            onClick={() => props.toggle("2")}>
                            GROUP REQUESTS
                            ({props.groupRequestCount})
                        </NavLink>
                    </NavItem>
                </Nav>
            </Col>
        </Row>
    )
};

export default RequestReceivedTabComponent;